/* global UserNotificationStore */

import {render} from 'react-dom';
import {Provider} from 'react-redux';

import {createStore} from '../utils/redux';

import reducer from './reducer';
import {addNotification, initialNotifications} from './actionCreators';

import UserNotifications from './components/UserNotifications';

const UserNotificationsNode = document.getElementById('user-notifications');
const CSRFMiddlewareTokenNode = UserNotificationsNode && UserNotificationsNode.getElementsByTagName('input')[0];

/* A document that does not hold what the template puts here is not one this bundle can render in:
   an offline copy of an older release, whose browser still loads the scripts from us. */
if (CSRFMiddlewareTokenNode) {
    const CSRFMiddlewareToken = CSRFMiddlewareTokenNode.value;
    const {messages, ...initial} = UserNotificationStore;

    const store = createStore(reducer, 'Start');

    store.dispatch(initialNotifications({...initial, CSRFMiddlewareToken}));

    messages.forEach(({text, tags}) => store.dispatch(addNotification(text, tags)));

    render(
        <Provider store={store}>
            <UserNotifications />
        </Provider>,
        UserNotificationsNode,
    );
}
